import { PAGES } from "../constants";

export const ALL_SUB_ORGANIZATIONS = `${PAGES} [AllSubOrganizations]`;
export const SUB_ORGANIZATION_FORM = `${PAGES} [SubOrganizationForm]`;

export const START_NEW_SUB_ORGANIZATION_SCREEN = `${SUB_ORGANIZATION_FORM} START`;
export const SAVE_SUB_ORGANIZATION = `${SUB_ORGANIZATION_FORM} SAVE_SUB_ORGANIZATION`;
export const START_ALL_SUB_ORGANIZATIONS_SCREEN = `${ALL_SUB_ORGANIZATIONS} START`;
export const GET_SUB_ORGANIZATION_LIST_BY_ORGANIZATION_ID = `${SUB_ORGANIZATION_FORM} GET_SUB_ORGANIZATION_LIST_BY_ORGANIZATION_ID`;

export const startNewSubOrganizationScreen = () => ({
  type: START_NEW_SUB_ORGANIZATION_SCREEN,
});

export const saveSubOrganization = ({ organizationId, subOrganization }) => ({
  type: SAVE_SUB_ORGANIZATION,
  payload: { organizationId, subOrganization },
});

export const startAllSubOrganizationsScreen = () => ({
  type: START_ALL_SUB_ORGANIZATIONS_SCREEN,
});

export const getSubOrganizationListByOrganizationId = (organizationId) => ({
  type: GET_SUB_ORGANIZATION_LIST_BY_ORGANIZATION_ID,
  payload: { organizationId },
});
